"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactHelmet = require("react-helmet");
var _react = _interopRequireDefault(require("react"));
const Seo = _ref => {
  let {
    title = '',
    description = '',
    url = ''
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, {
    htmlAttributes: {
      lang: 'en'
    },
    title: title,
    meta: [{
      name: 'description',
      content: description
    }],
    links: [{
      rel: 'canonical',
      href: url
    }]
  });
};
var _default = exports.default = Seo;